import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconChartSvg } from "./IconChartSvg.mjs";
const IconChart = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconChartSvg, ...iconProps });
};
export {
  IconChart
};
